import { TimeHM, minDayTime, maxDayTime } from "../../utils/times/models";
import { AreaType } from "../../utils/geographics/models";
import Url from "../../utils/validators/url"
import { PlaceCategory, PlaceCategories } from "./categories/models";

class Range {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.startTime = new TimeHM(jsonData.startTime)
		this.endTime = new TimeHM(jsonData.endTime)
	}

	intersects(otherRange) {
		if (this.startTime.isAfter(otherRange.endTime))
			return false

		if (this.endTime.isBefore(otherRange.startTime))
			return false

		return true
	}

	allDay() {
		return this.startTime.toMinutes() === 0 && this.endTime.toMinutes() === 1440;
	}

	asText() {
    	return this.startTime.asText() + " - " + this.endTime.asText();
  	}
}

class Day {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.ranges = [];
		if (jsonData.ranges) {
			for (var index = 0; index < jsonData.ranges.length; index++) {
				this.addRange(new Range(jsonData.ranges[index]));
			}
		}	
	}

	addRange(range) {
		this.ranges.push(range);
		this.ranges.sort((a,b) => {
			return a.startTime.toMinutes() - b.startTime.toMinutes();
		})
	}

	asText() {
		if (this.ranges.length === 0) {
	      return "Cerrado"
	    } if (this.ranges.length === 1 && this.ranges[0].allDay()) {
	      return "Abierto las 24hs"
	    } else {
	      var text = ""
	      this.ranges.forEach((range, index) => {
	        if (index > 0)
	          text += " / ";
	        text += range.asText()
	      })
	      return text
	    }
	}

	makeAlwaysOpen() {
		this.ranges = [new Range({startTime: minDayTime(), endTime: maxDayTime()})]
	}
}

class Schedule {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.days = [];

		if (jsonData.days) {
			for (var index = 0; index < jsonData.days.length; index++) {
				this.addDay(new Day(jsonData.days[index]));
			}
		} else {
			for (var indexDay = 0; indexDay < 7; indexDay++) {
				this.addDay(new Day());
			}
		}
	}

	addDay(day) {
		this.days.push(day);
	}

	makeAlwaysOpen() {
		this.days.forEach((day) => day.makeAlwaysOpen())
	}

}

class Place {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.id = jsonData.id;
		this.name = jsonData.name;
		this.ownerDni = jsonData.ownerDni;
		this.categoryId = jsonData.categoryId;
		this.placeCategory = new PlaceCategory(jsonData.placeCategory);
		this.address = jsonData.address;
		this.description = jsonData.description

		this.keywords = jsonData.keywords ? jsonData.keywords : [];
		this.phoneNumbers = jsonData.phoneNumbers ? jsonData.phoneNumbers : [];
		this.whatsApp = jsonData.whatsApp ? jsonData.whatsApp : [];
		this.delivery = jsonData.delivery ? jsonData.delivery : false;
		this.webSite = jsonData.webSite
		this.email = jsonData.email
		this.facebook = jsonData.facebook
		this.twitter = jsonData.twitter
		this.instagram = jsonData.instagram

		this.schedule = new Schedule(jsonData.schedule);
		this.baseSchedule = new Schedule(jsonData.baseSchedule);
		this.area = jsonData.area ? AreaType.getByName(jsonData.area.type).creator(jsonData.area) : null;

		this.photos = []
		if (jsonData.photos) {
			for (var index = 0; index < jsonData.photos.length; index++) {
				this.photos.push(new PlacePhoto(jsonData.photos[index]));
			}
		}
	}

	isValid() {
		if (!this.name || !this.name.trim())
			return false;

		if (this.ownerDni && this.ownerDni.toString().length !== 11)
			return false;

		if (!this.categoryId || !this.placeCategory || this.categoryId !== this.placeCategory.id)
			return false;

		if (!this.address || !this.address.trim())
			return false; 

		if (!this.area)
			return false;

		if (this.webSite && !Url.isValid(this.webSite))
			return false;

		if (this.facebook && !Url.isValidHostname(this.facebook,"www.facebook.com"))
			return false;

		if (this.twitter && !Url.isValidHostname(this.twitter,"twitter.com"))
			return false;

		if (this.instagram && !Url.isValidHostname(this.instagram,"www.instagram.com"))
			return false;

		return true;
	}

	addKeyword(keyword) {
		let newKeyword = keyword.normalize("NFD").toLowerCase();
		if (!this.keywords.includes(newKeyword)) {
			this.keywords.push(keyword);
			return true;
		} else {
			return false;
		}
	}

	setOwnerDni(dni) {
		if (!dni) {
			this.ownerDni = null;
		} else {
			this.ownerDni = parseInt(dni);
		}
	}

	removeKeyword(position) {
		this.keywords.splice(position,1);
	}

	hasPhoneNumber(phoneNumber) {
		return this.phoneNumbers.includes(phoneNumber);
	}

	removePhoneNumber(phoneNumber) {
		this.phoneNumbers.splice(this.phoneNumbers.indexOf(phoneNumber),1);
	}

	addPhoneNumber(phoneNumber) {
		this.phoneNumbers.push(phoneNumber);
	}

	getAllPhoneNumbers() {
		let numbers = [...new Set([...this.phoneNumbers, ...this.whatsApp])]
		numbers.sort()
		return numbers;
	}

	addWhatsApp(whatsApp) {
		this.whatsApp.push(whatsApp);
	}

	hasWhatsApp(whatsApp) {
		return this.whatsApp.includes(whatsApp);
	}

	removeWhatsApp(whatsApp) {
		this.whatsApp.splice(this.whatsApp.indexOf(whatsApp),1);
	}

	setCategory(placeCategory) {
		if (placeCategory != null) {
			this.placeCategory = placeCategory;
			this.categoryId = placeCategory.id;
		} else {
			this.placeCategory = null
			this.categoryId = null;
		}
	}

	addPhoto(photo) {
		this.photos.push(photo);
		this.photos.sort((a,b) => {
			return b.id - a.id; // La mas nueva primero
		})
	}

	removePhoto(photo) {
		this.photos = this.photos.filter(item => item !== photo);
	}

	makeAlwaysOpen() {
		this.baseSchedule.makeAlwaysOpen();
	}
}

class PlacePhoto {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.placeId = jsonData.placeId;
		this.binId = jsonData.binId;
	}

} 

export { PlaceCategories, PlaceCategory, Range, Day, Schedule, Place, PlacePhoto };